/** The Intuigence logo dot that heads every agent-status line in the chat (Figma), as the old chat drew it. */
export default function AgentDot() {
  return <img src="/images/intuai-logo-icon.svg" alt="" aria-hidden className="size-4 shrink-0" />
}
